export const OSS_BUCKET = process.env.REACT_APP_OSS_BUCKET || 'mobuffer';
export const OSS_BASE_URL = process.env.REACT_APP_OSS_BASE_URL || 'https://mobuffer.oss-us-west-1.aliyuncs.com/';
// export const OSS_BUCKET = process.env.REACT_APP_OSS_BUCKET || 'mocnbuffer';
// export const OSS_BASE_URL = process.env.REACT_APP_OSS_BASE_URL || 'https://mocnbuffer.oss-cn-hangzhou.aliyuncs.com/';
